import { FamilyClassroom } from '@tadpoles/common'
import type { Static } from 'typebox'
import { Value } from 'typebox/value'

import type {
    MappedPersistenceCollectionDefinition,
    PersistenceCollection
} from '@tadpoles/persistence'

export type ClassroomRecord = Static<typeof FamilyClassroom>
export type FamilyClassroomStore = PersistenceCollection<ClassroomRecord, 'key'>

export const ClassroomCollectionDefinition: MappedPersistenceCollectionDefinition<
    typeof FamilyClassroom,
    ClassroomRecord,
    'key'
> = {
    kind: 'classroom',
    scope: 'user',
    primaryKey: 'key',
    modelSchema: FamilyClassroom,
    encode: (value) => Value.Decode(FamilyClassroom, value),
    decode: (value) => Value.Encode(FamilyClassroom, value)
}
